import { AppBar, Box, Tab, Tabs, Toolbar } from "@material-ui/core"
import { useEffect, useState } from "react"
import type { ReactElement } from "react"
import { Link } from "react-router-dom"
import { AvatarWrapper, SearchWidget } from ".."
import { useBrandName, useIsSafeExamBrowser, useTabletBreakpoint } from "../../../hooks"
import { history } from "../../../redux"
import { BrandLogo } from "../../atoms"
import { SearchBarProvider } from "../../organisms"

import "./page-header.styles.scss"
import { useTranslation } from "react-i18next"

export function PageHeader(): ReactElement {
  const brandName: string = useBrandName()
  const [widgetOpen, setWidgetOpen] = useState<boolean>(false)
  const isTablet: boolean = useTabletBreakpoint()
  const isSafeExamBrowser: boolean = useIsSafeExamBrowser()
  const { t } = useTranslation(["pageHeader", "general", "search"])

  const [activeTab, setActiveTab] = useState<number | boolean>(0)
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    const { pathname } = history.location
    switch (pathname) {
      case "/":
        setActiveTab(0)
        break
      case `/Mijn${brandName}`:
        setActiveTab(2)
        break
      default:
        pathname.includes("/content") ? setActiveTab(1) : setActiveTab(false)
        break
    }
  }, [history.location.pathname])

  return (
    <AppBar position="relative" elevation={0} className="page-header" color="transparent" data-mdat-module="navbar">
      <Toolbar className="page-header-toolbar">
        <Box display="flex" alignItems="center">
          <Link to="/" data-mdat-item-id="logo">
            <BrandLogo />
          </Link>
          {(!widgetOpen || !isTablet) && (
            <Box className="page-header-links" id="page-header-navigation-box">
              <Tabs value={activeTab} indicatorColor="primary">
                <Tab component={Link} to="/" label={t("pageHeader:start")} />
                <Tab component={Link} to="/content" label={t("pageHeader:index")} />
                {!isSafeExamBrowser && (
                  <Tab
                    component={Link}
                    to={`/Mijn${brandName}`}
                    label={t("general:myAtlas", {
                      brandName
                    })}
                  />
                )}
              </Tabs>
            </Box>
          )}
        </Box>
        <Box display="flex" alignItems="center">
          <Box className="search-licence-inputs">
            <SearchBarProvider
              id="page-header-searchbar"
              disableSync
              small
              compactDisplay
              placeholder={t("search:searchHeader")}
            >
              <SearchWidget
                disableClose={!isTablet}
                open={widgetOpen}
                onOpen={() => setWidgetOpen(true)}
                onClose={() => setWidgetOpen(false)}
              />
            </SearchBarProvider>
          </Box>

          <AvatarWrapper />
        </Box>
      </Toolbar>
    </AppBar>
  )
}
